/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateSparkLightningInvoiceRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {CreateSparkLightningInvoiceResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const createSparkLightningInvoice = (request: CreateSparkLightningInvoiceRequest, options?: CashRequestOptions) => post<CreateSparkLightningInvoiceRequest, CreateSparkLightningInvoiceResponse>("/2.0/cash/create-spark-lightning-invoice", request, {...options, rejectOnError: true })